<td-layout
  #layout
  [mode]="'over'"
  [sidenavWidth]="(media.registerQuery('gt-xs') | async) ? '250px' : '65%'"
>
  <td-navigation-drawer navigationRoute="/" color="primary">
    <ng-container *ngIf="menu">
      <ng-container *ngFor="let section of menu.sections">
        <p class="menu-section-header" *ngIf="section.headerOnly">{{ section.header }}</p>
        <mat-expansion-panel *ngIf="section.header && !section.headerOnly">
          <mat-expansion-panel-header>
            {{ section.header }}
          </mat-expansion-panel-header>
          <mat-nav-list class="nav-list">
            <ng-container *ngFor="let item of section.menuItems">
              <!-- regular link -->
              <a
                *ngIf="(item.hasPermissions == null || item.hasPermissions()) && !item.isExternal"
                mat-list-item
                (click)="!media.query('gt-md') && layout.close()"
                [tdLayoutClose]="true"
                [routerLink]="[item.route]"
                [routerLinkActive]="['active']"
              >
                <mat-icon mat-list-icon>{{ item.icon }}</mat-icon> {{ item.title }}
              </a>
              <!-- external link -->
              <a
                *ngIf="(item.hasPermissions == null || item.hasPermissions()) && item.isExternal"
                mat-list-item
                href="{{ item.route }}"
                target="_blank"
                ><mat-icon mat-list-icon>{{ item.icon }}</mat-icon>
                {{ item.title }}
              </a>
              <ng-container *ngIf="item.children != null && item.children?.length > 0">
                <ng-container *ngFor="let subItem of item.children">
                  <mat-list-item *ngIf="subItem.hasPermissions == null || subItem.hasPermissions()">
                    <a
                      matLine
                      (click)="!media.query('gt-md') && layout.close()"
                      [tdLayoutClose]="true"
                      [routerLink]="[subItem.route]"
                      [routerLinkActive]="['active']"
                    >
                      <mat-icon mat-list-icon>{{ subItem.icon }}</mat-icon>
                      {{ subItem.title }}
                    </a>
                  </mat-list-item>
                </ng-container>
              </ng-container>
            </ng-container>
          </mat-nav-list>
        </mat-expansion-panel>

        <ng-container *ngIf="!section.header">
          <mat-nav-list class="nav-list">
            <ng-container *ngFor="let item of section.menuItems">
              <!-- regular link -->
              <a
                *ngIf="(item.hasPermissions == null || item.hasPermissions()) && !item.isExternal"
                mat-list-item
                (click)="!media.query('gt-md') && layout.close()"
                [tdLayoutClose]="true"
                [routerLink]="[item.route]"
                [routerLinkActive]="['active']"
              >
                <mat-icon mat-list-icon>{{ item.icon }}</mat-icon> {{ item.title }}
              </a>
              <!-- external link -->
              <a
                *ngIf="(item.hasPermissions == null || item.hasPermissions()) && item.isExternal"
                mat-list-item
                href="{{ item.route }}"
                target="_blank"
                ><mat-icon mat-list-icon>{{ item.icon }}</mat-icon>
                {{ item.title }}
              </a>
              <ng-container *ngIf="item.children != null && item.children?.length > 0">
                <ng-container *ngFor="let subItem of item.children">
                  <mat-list-item *ngIf="subItem.hasPermissions == null || subItem.hasPermissions()">
                    <a
                      matLine
                      (click)="!media.query('gt-md') && layout.close()"
                      [tdLayoutClose]="true"
                      [routerLink]="[subItem.route]"
                      [routerLinkActive]="['active']"
                    >
                      <mat-icon mat-list-icon>{{ subItem.icon }}</mat-icon>
                      {{ subItem.title }}
                    </a>
                  </mat-list-item>
                </ng-container>
              </ng-container>
            </ng-container>
          </mat-nav-list>
        </ng-container>
      </ng-container>
    </ng-container>
  </td-navigation-drawer>
  <router-outlet></router-outlet>
</td-layout>
